import { create } from "zustand";

/**
 * Estado de la conexión. Combina el aviso del navegador (online/offline) con
 * los fallos de red reales de la API: `navigator.onLine` puede decir "online"
 * con una red que no responde.
 */
interface NetworkState {
  online: boolean;
  setOnline: (online: boolean) => void;
}

export const useNetwork = create<NetworkState>((set) => ({
  online: typeof navigator === "undefined" ? true : navigator.onLine,
  setOnline: (online) => set({ online }),
}));

export function installNetworkListeners(onBackOnline: () => void): void {
  if (typeof window === "undefined") return;
  window.addEventListener("offline", () => useNetwork.getState().setOnline(false));
  window.addEventListener("online", () => {
    useNetwork.getState().setOnline(true);
    onBackOnline();
  });
}

export function reportNetworkFailure(): void {
  useNetwork.getState().setOnline(false);
}

export function reportNetworkSuccess(): void {
  if (!useNetwork.getState().online) useNetwork.getState().setOnline(true);
}
